/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const defaultDomains = [{ type: 'AccommodationProviders', priority: 1 }];
export const localeOptions = [
  { id: 'en', name: 'en-English', direction: 'ltr' },
  { id: 'es', name: 'es-Español', direction: 'ltr' },
  { id: 'zh', name: 'zh-简体中文 (SC)', direction: 'ltr' },
  { id: 'de', name: 'de-Deutsche', direction: 'ltr' },
  { id: 'fr', name: 'fr-français', direction: 'ltr' },
  { id: 'hk', name: 'hk-繁体中文 (TC)', direction: 'ltr' },
  { id: 'mi', name: 'mi-Maori', direction: 'ltr' },
  { id: 'id', name: 'id-Bahasa Indonesia', direction: 'ltr' },
  { id: 'tl', name: 'tl-Tagalog (Filipino)', direction: 'ltr' },
  { id: 'vi', name: 'vi-vietnamese', direction: 'ltr' },
  { id: 'ko', name: 'ko-한국인', direction: 'ltr' },
  { id: 'ar', name: 'ar-عربي', direction: 'ltr' },
  { id: 'ru', name: 'ru-Русский', direction: 'ltr' },
  { id: 'fi', name: 'fi-Suomalainen', direction: 'ltr' },
  { id: "ja", name: "ja-Japanese", direction: 'ltr' },
  { id: "th", name: "th-ไทย", direction: 'ltr' },
  { id: "nl", name: "nl-Nederlands", direction: 'ltr' },
];
export const hotelOptions = [
  { id: '1', name: 'President Hotel' },
  { id: '2', name: 'Grand Windsor' },
  { id: '3', name: 'Fat Camel' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const searchPath = '/app/pages/search';
export const servicePath = 'https://api.coloredstrategies.com';

/* 
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive = true;
export const defaultColor = 'light.purple';
export const defaultDirection = 'ltr';
export const isDarkSwitchActive = true;
export const themeColorStorageKey = '__theme_color';
